import React from "react";

export default function NumberInput({
  beverageName,
  handleBeverage,
  quantity,
  descriptionId, // New prop to link with the description
}) {
  function decrementValue() {
    if (quantity > 0) {
      handleBeverage(beverageName, quantity - 1);
    }
  }

  function incrementValue() {
    handleBeverage(beverageName, quantity + 1);
  }

  function changeFromInput(event) {
    const number = Number(event.target.value);
    if (isNaN(number) || number < 0) {
      handleBeverage(beverageName, 0);
    } else {
      handleBeverage(beverageName, number);
    }
  }

  return (
    <div className="relative flex items-center w-full">
      <button
        onClick={decrementValue}
        type="button"
        aria-label={`Reduce ${beverageName}`}
        className="bg-slate-100 hover:bg-slate-50 border border-slate-200 rounded-s-lg py-1 px-1.5 h-6 sm:h-8 focus:outline-none"
      >
        <svg
          className="w-3 h-3 text-gray-900 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 18 2"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="4"
            d="M1 1h16"
          />
        </svg>
      </button>
      <input
        value={quantity}
        onChange={changeFromInput}
        type="text"
        aria-labelledby={descriptionId}
        className="bg-white w-full font-bold text-base sm:text-lg border-x-0 border border-slate-200 h-6 sm:h-8 text-center text-gray-900 block focus:outline-none"
      />
      <button
        onClick={incrementValue}
        type="button"
        aria-label={`Increase ${beverageName}`}
        className="bg-slate-100 hover:bg-slate-50 border border-slate-200 rounded-e-lg py-1 px-1.5 h-6 sm:h-8 focus:outline-none"
      >
        <svg
          className="w-3 h-3 text-gray-900 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 18 18"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="4"
            d="M9 1v16M1 9h16"
          />
        </svg>
      </button>
    </div>
  );
}
